module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop-main"
  }, [_c('div', {
    staticClass: "admin-body"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.tableParams,
      "label-width": "80px",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态",
      "clearable": ""
    },
    model: {
      value: (_vm.tableParams.status),
      callback: function($$v) {
        _vm.$set(_vm.tableParams, "status", $$v)
      },
      expression: "tableParams.status"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "禁用",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    key: 1,
    attrs: {
      "label": "启用",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.queryTaskClick
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.insertTaskClick
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData.list,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "类型",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "编码",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "售价",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customTextStatus",
      "label": "自定义文字",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.customTextStatus == 0) ? _c('span', {
          staticStyle: {
            "color": "orange",
            "font-weight": "400"
          }
        }, [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.customTextStatus == 1) ? _c('span', {
          staticStyle: {
            "color": "blue",
            "font-weight": "400"
          }
        }, [_vm._v("有")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "red",
            "font-weight": "600"
          }
        }, [_vm._v("禁用")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "green",
            "font-weight": "600"
          }
        }, [_vm._v("启用")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sort",
      "label": "排序",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editTaskInfoClick(scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.toggleStatusClick(scope.row)
            }
          }
        }, [_vm._v("切换状态")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.tableData.pageNum,
      "page-size": _vm.tableData.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.tableData.total
    },
    on: {
      "prev-click": function($event) {
        return _vm.changePage(-1)
      },
      "next-click": function($event) {
        return _vm.changePage(1)
      },
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogTaskInfo.newUpdateTitle,
      "visible": _vm.dialogTaskInfo.newUpdateVisible,
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.dialogTaskInfo, "newUpdateVisible", $event)
      }
    }
  }, [_c('div', {
    staticClass: "dialog-person-body"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.dialogTaskInfo.taskInfo,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "name", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "售价(元)"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.price),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "price", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "左图片"
    }
  }, [(_vm.dialogTaskInfo.taskInfo.leftTextUrl) ? _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.dialogTaskInfo.taskInfo.leftTextUrl,
      "fit": "fit",
      "preview-src-list": [_vm.dialogTaskInfo.taskInfo.leftTextUrl]
    }
  }) : _vm._e(), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUrl,
      "headers": _vm.uploadHeaders,
      "on-remove": _vm.handleRemoveByLeftPic,
      "limit": 1,
      "on-exceed": _vm.handleExceedByLeftPic,
      "on-success": _vm.handleSuccessByLeftPic,
      "file-list": _vm.leftFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，宽1195，高1760")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "右图片"
    }
  }, [(_vm.dialogTaskInfo.taskInfo.rightTextUrl) ? _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.dialogTaskInfo.taskInfo.rightTextUrl,
      "fit": "fit",
      "preview-src-list": [_vm.dialogTaskInfo.taskInfo.rightTextUrl]
    }
  }) : _vm._e(), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUrl,
      "headers": _vm.uploadHeaders,
      "on-remove": _vm.handleRemoveByRightPic,
      "limit": 1,
      "on-exceed": _vm.handleExceedByRightPic,
      "on-success": _vm.handleSuccessByRightPic,
      "file-list": _vm.rightFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，宽1195，高1760")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景图"
    }
  }, [(_vm.dialogTaskInfo.taskInfo.bgPicUrl) ? _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.dialogTaskInfo.taskInfo.bgPicUrl,
      "fit": "fit",
      "preview-src-list": [_vm.dialogTaskInfo.taskInfo.bgPicUrl]
    }
  }) : _vm._e(), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUrl,
      "headers": _vm.uploadHeaders,
      "on-remove": _vm.handleRemoveByRightPic,
      "limit": 1,
      "on-exceed": _vm.handleExceedByRightPic,
      "on-success": _vm.handleSuccessByRightPic,
      "file-list": _vm.bgFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，宽5160，高1760")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "LOGO"
    }
  }, [(_vm.dialogTaskInfo.taskInfo.logoUrl) ? _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.dialogTaskInfo.taskInfo.logoUrl,
      "fit": "fit",
      "preview-src-list": [_vm.dialogTaskInfo.taskInfo.logoUrl]
    }
  }) : _vm._e(), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUrl,
      "headers": _vm.uploadHeaders,
      "on-remove": _vm.handleRemoveByLogoPic,
      "limit": 1,
      "on-exceed": _vm.handleExceedByLogoPic,
      "on-success": _vm.handleSuccessByLogoPic,
      "file-list": _vm.logoFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，宽高为1：1，建议300*300")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Banner图"
    }
  }, [(_vm.dialogTaskInfo.taskInfo.bannerUrl) ? _c('el-image', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.dialogTaskInfo.taskInfo.bannerUrl,
      "fit": "fit",
      "preview-src-list": [_vm.dialogTaskInfo.taskInfo.bannerUrl]
    }
  }) : _vm._e(), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUrl,
      "headers": _vm.uploadHeaders,
      "on-remove": _vm.handleRemoveByBannerPic,
      "limit": 1,
      "on-exceed": _vm.handleExceedByBannerPic,
      "on-success": _vm.handleSuccessByBannerPic,
      "file-list": _vm.bannerFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，宽5160，高1200")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.sort),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "sort", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态",
      "clearable": ""
    },
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.status),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "status", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.status"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "label": "禁用",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    key: 1,
    attrs: {
      "label": "启用",
      "value": 1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newUpdateTaskClick
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45cfa042"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/hand/text_mgr.vue
// module id = 1184
// module chunks = 2